import { render, staticRenderFns } from "./AwardPage.vue?vue&type=template&id=7b383b40&scoped=true"
import script from "./AwardPage.vue?vue&type=script&lang=ts"
export * from "./AwardPage.vue?vue&type=script&lang=ts"
import style0 from "./AwardPage.vue?vue&type=style&index=0&id=7b383b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b383b40",
  null
  
)

export default component.exports